<template lang="pug">
  .site-container
    .b-successful-register-page.empty-page(v-if="success")
      ._container.empty-page-container
        ._content.empty-page-content
          Icon(name="successful")
          h1._subtitle Поздравляем!
          h2._title Вы успешно зарегистрировались в системе!
          p._desc На указанный e-mail отправлен запрос на подтверждение регистрации. Ссылка в письме действительна в течение 24 часов. Обратите внимание, что письмо может автоматически попасть в папку "Оповещения" или другие папки, в зависимости от настроек почтовой системы.
          p._desc Если в течение 10 минут письмо не пришло, напишите нам на адрес &nbsp;
            a._link(href="mailto:support@teroom.ru") support@teroom.ru.
        AuthFooter(hideEmail)
    .b-register-page.empty-page(v-else)
      ._container.empty-page-container
        ._content.empty-page-content
          AuthLogo(page="register")._left
          AuthRegisterForm(@register="success = true")._right
        AuthFooter
        YaMetrika(ref="metrika")
</template>

<script>
import AuthLogo from '@/components/AuthLogo.vue';
import AuthRegisterForm from '@/components/AuthRegisterForm.vue';
import AuthFooter from '@/components/AuthFooter.vue';
import YaMetrika from '@/components/app/YaMetrika.vue';

export default {
  components: {
    AuthLogo,
    AuthRegisterForm,
    AuthFooter,
    YaMetrika,
  },
  data() {
    return {
      success: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.register-page {
  &__content {
    padding: 32px 0;
  }

  &__left {
    display: flex;
    text-align: center;
    padding-right: 20px;
    flex-direction: column;
    color: var(--color-white);
  }

  &__right {
    text-align: center;
    padding: 19px 43px;
    border-left: 1px solid var(--color-purple);
  }

  @media (max-width: 1024px) {
    &__container {
      width: 100%;
    }

    &__content {
      flex-direction: column;
    }

    &__left {
      width: 100%;
      padding: 0 0 20px;
    }

    &__right {
      padding: 25px 0 0;
      border-top: 1px solid var(--color-purple);
      border-left: none;
    }
  }

  @media (max-width: 768px) {
    &__content {
      padding: 17px 20px 30px 20px;
    }

    &__right {
      width: 100%;
      padding-top: 25px;
      margin-bottom: 0;
      border-bottom: none;
      padding-bottom: 0;
    }
  }
}

.successful-register-page {

  &__content {
    flex-direction: column;
    text-align: center;
    margin-bottom: 30px;
  }

  svg {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    margin-bottom: 22px;
  }
  &__subtitle {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    color: var(--color-green-st);
    margin-bottom: 17px;
  }
  &__title {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 34px;
    color: var(--color-middle-gray);
  }
  &__desc {
    max-width: 560px;
    margin: 0 auto;
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-middle-gray);
    &:not(:last-child) {
      margin-bottom: 44px;
    }
  }
  &__link {
    color: var(--color-accent);
  }

  @media (max-width: 500px) {
    &__container {
      padding: 20px 15px;
    }

    &__content {
      padding: 30px 20px;
    }

    &__title {
      margin-bottom: 12px;
    }

    &__desc:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
